module.exports = __webpack_public_path__ + "static/media/PersonasJuridicas.d84f0ea9.png";